import axios from "../utils/axios";
const termsOfService = "terms-of-service";

export const getOptOutStatus = () => axios.get(`${termsOfService}`);

export const updateOptOutStatus = (status: boolean) =>
  axios.put(termsOfService, {
    tos_opt_out: status,
  });
